import React from 'react';
import { Property } from 'csstype';

import { styled } from '@mui/material/styles';
import Box, { BoxProps } from '../material/Box';

type ToggleVisibilityContainerProps = {
  isVisible: boolean;
  display?: Property.Display;
  children: React.ReactElement;
} & BoxProps;

type StyledContainerProps = {
  isVisible: boolean;
  display?: Property.Display;
};

const StyledContainer = styled(Box, {
  shouldForwardProp: (prop) => {
    return prop !== 'isVisible' && prop !== 'display';
  },
})<StyledContainerProps>(({ isVisible, display }) => ({
  visibility: isVisible ? 'visible' : 'hidden',
  display: display || 'block',
}));

const ToggleVisibilityContainer: React.FC<ToggleVisibilityContainerProps> = ({
  children,
  isVisible,
  display,
  ...boxProps
}) => {
  return (
    <StyledContainer isVisible={isVisible} display={display} {...boxProps}>
      {children}
    </StyledContainer>
  );
};

export default ToggleVisibilityContainer;
